import {useMutation, useQuery} from 'admin/lib/apollo'
import {gql} from 'admin/lib/apollo'

export const TEXT_MESSAGE_FIELDS = gql`
  fragment TextMessageFields on TextMessage {
    id
    contentWithPlaceholders
    sender
    recipients {
      id
      content
      e164MobileNumber
      status
      account {
        id
        displayName @client
        contactFullName @client
        name
        contactFirstName
        contactLastName
      }
    }
    createdAt
  }
`

export const QUERY = gql`
  ${TEXT_MESSAGE_FIELDS}
  query GetTextMessage($textMessageId: ID!) {
    textMessage(id: $textMessageId) {
      ...TextMessageFields
    }
  }
`

export const MUTATION = gql`
  ${TEXT_MESSAGE_FIELDS}
  mutation SendTextMessage($accountIds: [String!], $groupIds: [String!], $contentWithPlaceholders: String!) {
    textMessage: sendTextMessage(
      accountIds: $accountIds
      groupIds: $groupIds
      contentWithPlaceholders: $contentWithPlaceholders
    ) {
      ...TextMessageFields
    }
  }
`

export default (organisationId, textMessageId) => {
  const variables = {organisationId, textMessageId}

  const {data: {textMessage = {}} = {}, error: getError} = useQuery(QUERY, {
    variables: {organisationId, textMessageId},
    skip: !textMessageId
  })

  const [create, {error: createError, loading: createLoading}] = useMutation(MUTATION, {
    variables,
    flash: 'Text messages queued',
    refetchQueries: ['GetTextMessages']
  })

  return {
    textMessage,
    errors: getError || createError || {},
    loading: createLoading,
    create
  }
}
